import { render, staticRenderFns } from "./Personalreport.vue?vue&type=template&id=5b2876b6&scoped=true"
import script from "./Personalreport.vue?vue&type=script&lang=js"
export * from "./Personalreport.vue?vue&type=script&lang=js"
import style0 from "./Personalreport.styles.less?vue&type=style&index=0&id=5b2876b6&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2876b6",
  null
  
)

export default component.exports